// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","desktop_header":"App_desktop_header__RxOTE","mobile_header":"App_mobile_header__R1ZtI","mobile_header_login":"App_mobile_header_login__a8GQm"};